import { GPackageItemModel, GPackagesModelModel } from "../g-settings/GSettingViewModel";
import { ItemCodeModel, ItemViewModel1 } from "../ItemViewModel";

export class SavePurchaseMasterRequest {
    public id: number;
    public refId: string;
    public invNumber: string;
    public validity: number;
    public debitAcc: ItemViewModel1;
    public supCreditAcc: ItemViewModel1;
    public supCreditAccEmail: ItemViewModel1;
    public statusType: ItemViewModel1;
    public tag: ItemViewModel1;
    public supplier: ItemViewModel1;
    public wareHouse: ItemViewModel1;
    public remarks: string;
    public staus: string;
    public invAmount: number;
    public paidAmount: number;
    public vatValue: number;
    public vatAmount: number;
    public isPaymentDone: boolean;
    public paymentType: number;
    public isEmailRequired: boolean;
    public transactionDate: Date;
    public requiredDate: Date;
    public Attachment: string;
    public purchaseDetail: PurchaseDetailModel[];
    public attachmentList: any[];
    public isLinked: boolean = false;
}

export class PurchaseDetailModel {
    public id: number;
    public purchaseMast: ItemViewModel1;
    public itemCode: string;
    public itemName: string;
    public itemType: string;
    public item: ItemViewModel1;
    public itemDetail: string;
    public quantity: number;
    public availabelQuantity: number;
    public currentStock: number;
    public maxStock: number;
    public minStock: number;
    public maxQuantity: number;

    public availabilityStatus: boolean;
    public uom: string;
    public remarks: string;
    public purchasePrice: number;
    public salePrice: number;
    public costOfGoodSold: number;
    public vatType: string;
    public vatValue: number;
    public vatAmount: number;
    public totalAmount: number;
    public discountAmount: number;
    public discount: number;
    public batch: number;
    public oldMast: number;
}


export class SaveGInstallmentRequest {

    public id: number;
    public amount: number;
    public invoiceNumber: number;
    public invoiceAmount: number;
    public remainingAmount: number;
    public paidAmount: number;
    public gPurchase: ItemViewModel1;
    public gSale: ItemViewModel1;
    public creditAccount: ItemViewModel1;
    public debitAccount: ItemViewModel1;
    public bulkPayment: ItemViewModel1;
    public isPurchase: boolean;
    public isBulkPayments: boolean;
    public transactionDate: Date;
    public remarks: string;
    public file: any;
    public attachment: string;
    public isDisable: boolean = false;
}



export class SaveSaleMasterRequest {
    public id: number;
    public uniqueId: string;
    public refId: string;
    public invNumber: number;
    public vatValue: number;
    public customerDiscount: number;
    public transactionDate: Date;
    public validity: number;
    public gVehicle: ItemCodeModel;
    public gCustomer: ItemViewModel1;
    public customerAcc: ItemViewModel1;
    public creditAcc: ItemViewModel1;
    public customerAccEmail: ItemViewModel1;
    public statusType: ItemViewModel1;
    public gTags: ItemViewModel1;
    public spsType: ItemViewModel1;
    public gWareHouse: ItemViewModel1;
    public brand: ItemViewModel1;
    public model: ItemViewModel1;
    public remarks: string;
    public paymentType: number;
    public status: string;
    public invAmount: number;
    public paidAmount: number;
    public isPaymentDone: boolean;
    public isCredit: boolean;
    public isCounterSale: boolean;
    public odometer: number;
    public attachment: string;
    public file: any = [];
    public driverName: string;
    public registrationNumber: string;
    public driverPhone: string;
    public saleDetails: SaleDetailModel[];
    public customerComplains: ComplainsSuggestionsModel[];
    public salesTagsList: TagsModel[];
    public findings: ComplainsSuggestionsModel[];
    public attachmentList: string;
    public invoicesList: string;
    public salesTags: TagsModel[];
    public packageDetail: GPackagesModel[];
    public spareParts: SaleDetailModel[];
    public services: SaleDetailModel[];
    public isEmailRequired: boolean = true;
    public isQRGenerate: boolean = false;
    public partsAmount: number;
    public serviceAmount: number;
    public totalExpense: number;
    public allowedExpense: number;
}

export class SaleDetailModel {
    public id: number;
    public saleMast: ItemViewModel1;
    public itemCode: string;
    public itemName: string;
    public itemDetail: string;
    public item: ItemViewModel1;
    public itemType: ItemViewModel1;
    public quantity: number;
    public availabelQuantity: number;
    public availabilityStatus: boolean;

    public uom: string;
    public remarks: string;
    public purchasePrice: number;
    public salePrice: number;
    public costOfGoodSold: number;
    public vatType: string;
    public vatValue: number;
    public vatAmount: number;
    public totalAmount: number;
    public totalVatAmount: number;
    public discount: number;
    public discountAmount: number;
    public discountedRate: number;
    public rate: number;
    public batch: number;
    public isCompleted: boolean;
    public isOldItem: boolean;
    public isInventry: boolean = true;
}

export class ComplainsSuggestionsModel {
    public id: number;
    public name: string;
    public gComplains: ItemViewModel1;
    public complainsType: string;
}

export class TagsModel {
    public id: number;
    public fkTagId: number;
    public name: string;
    public tagsType: ItemViewModel1;
}

export class GPackagesModel {
    public id: number;
    public name: string;
    public description: string;
    public packageType: ItemViewModel1;
    public partsAmount: number;
    public serviceAmount: number;
    public totalAmount: number;
    public discountAmount: number;
    public packageAmount: number;
    public discount: number;
    public isGenericModel: boolean;
    public CreatedDate?: Date;
    public gPackagesModel: GPackagesModelModel[];
    public gPackagesItem: GPackageItemModel[];
    public services: GPackageItemModel[];
    public spareParts: GPackageItemModel[];
}



export class SaveStockAdjustmentRequest {

    public id: number;
    public refId: string;
    public amount: number;
    public debitAccount: ItemViewModel1;
    public gWareHouse: ItemViewModel1;
    public creditAccount: ItemViewModel1;
    public isExpense: boolean;
    public isRevenue: boolean;
    public transactionDate: Date;
    public remarks: string;
    public lastAmount: number;
    public newAmount: number;
    public stockAdjustmentDetail: StockAdjustmentDetailModel[];
}

export class StockAdjustmentDetailModel {

    public id: number;
    public gStockAdjustment: ItemViewModel1;
    public gWareHouse: ItemViewModel1;
    public item: ItemViewModel1;
    public quantity: number;
    public oldQuantity: number;
    public newQuantity: number;
    public costOfGoodSold: number;
    public totalAmount: number;
    public newAmount: number;
    public transactionDate: Date;
    public isDisable: boolean = false;
    public isLock?: boolean;
    public name: string;
}


export class SaveInventoryTransfersRequest {
    public id: number
    public fromWareHouse: ItemViewModel1;
    public toWareHouse: ItemViewModel1;
    public transferDate: Date;
    public inventoryDetailList: Array<GInventoryDetailModel>;
}
export class GInventoryDetailModel {
    public id: number;
    public transfer: ItemViewModel1;
    public item: ItemViewModel1;
    public quantity: number;
    public costOfGoodSold: number;
    public fromOldQuantity: number;
    public fromNewQuantity: number;
    public transferQuantity: number;
    public toOldQuantity: number;
    public toNewQuantity: number;
}